import request, { IPage, IMediaPage, IWorkspaceResponse } from '/@/api/http/request'

// 创建手飞任务
export const getFlyTask = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/workspaces/flight-tasks/manual'
  const result = await request.post(url, body)
  return result.data
}

// 任务列表
export const getFlyTaskList = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/workspaces/page/jobs/list'
  const result = await request.post(url, body)
  return result.data
}

// 上传报告
export const getUploadReport = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/workspaces/jobs/upload-report'
  const result = await request.post(url, body)
  return result.data
}

// 生成报告
export const getGenerateReport = async function (jobId: any): Promise<IWorkspaceResponse<any>> {
  const url = `/wayline/api/v1/workspaces/jobs/generate-report/${jobId}`
  const result = await request.post(url, jobId)
  return result.data
}

// 获取任务上传的报告列表
export const getReportList = async function (jobId: any): Promise<IWorkspaceResponse<any>> {
  const url = `/wayline/api/v1/workspaces/jobs/get-upload-report/${jobId}`
  const result = await request.post(url, jobId)
  return result.data
}

// 作废报告
export const getVoidReport = async function (id: any): Promise<IWorkspaceResponse<any>> {
  const url = `/wayline/api/v1/workspaces/jobs/nullify-report/${id}`
  const result = await request.post(url, id)
  return result.data
}

// 报告列表
export interface reportQueryParam {
    job_name: string,
    workspace_id: string,
    start_time: string,
    end_time: string,
    report_name: string
}

export interface reportPageRequest {
    page: number
    page_size: number
    param: reportQueryParam
}

export const getReportPage = async function (body: reportPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/workspaces/jobs/report-list'
  const result = await request.post(url, body)
  return result.data
}
